import React from 'react'
import Layout from '../components/Layout'

const Invite = () => {
    const today = new Date();

    const [InviteInputs, setInviteInputs] = React.useState({
        theme: "Classic",
        color: "#ff6ec4",
        secondary_color: "#7873f5",
        title: "You're Invited!",
        subtitle: "Join us for a Special Celebration",
        event: "Birthday Party",
        date: today.toISOString().split("T")[0],
        time: "6:00 PM - 8:00 PM",
        venue: "Sunshine Banquet Hall",
        footer: "We look forward to celebrating with you!"
    });
    // const handleImageUpload = (e) => {
    //         const file = e.target.files[0];
    //         if (file) {
    //             setImage(URL.createObjectURL(file));
    //         }
    //     };

    const handleInviteInputChange = (k, v) => {
        // setInviteInputs(prevData => ({
        //     ...prevData, [k]: v
        // }));
        setInviteInputs(prev => {
            let updated = {
                ...prev,
                [k]: v
            };

            if (k === "theme") {
                if (v.toLowerCase() !== "classic") {
                    const {
                        ...rest
                    } = updated;

                    updated = {
                        ...rest,
                        upload_image: ""
                    };
                }
                else {
                    const {
                        upload_image,
                        ...rest
                    } = updated;

                    updated = {
                        ...rest,
                    };
                }
            }

            return updated;
        });
        if (k === "color") {
            document.documentElement.style.setProperty("--primary-color", v);
        }
        if (k === "secondary_color") {
            document.documentElement.style.setProperty("--secondary-color", v);
        }
        if (k === "upload_image") {
            const reader = new FileReader();
            reader.onload = (event) => {
                const dataUrl = event.target.result;
                document.documentElement.style.setProperty("--primary-image", `url(${dataUrl})`);
            };
            reader.readAsDataURL(v);
        }
    }

    return (
        <Layout
            header="Create Stunning Invitations"
            description="Design and customize invitations for any occasion, including birthdays, weddings, parties, and corporate events.
            Personalize text, colors, fonts, and images. Make every invitation memorable and uniquely yours."
            name="INVITE"
            data={[]}
            inputData={InviteInputs} handleInputDataChange={handleInviteInputChange}
            styles={["Classic", "Modern", "Photo"]} />
    )
}

export default Invite;